import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import {
  CommunicationModel,
  FollowUpCommunicationModel
} from 'src/models/customer/communication';
import { API_url } from '../api.setup';
import { log } from 'console';

const API_Controller = '/CustomerCommunication';

export const CommunicationService = {
  getData: async (data) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/GetByCustomerId?customerId=${data}`
      );

      return response.data as CommunicationModel[];
    } catch (error) {
      throw error;
    }
  },
  addData: async (customerToUpdate: any) => {
    try {
      const reqModel = {
        id: customerToUpdate.id,
        customerId: customerToUpdate.customerId,
        date: customerToUpdate.date,
        communicationTypeId: customerToUpdate.communicationTypeId,
        communicationSubjectId: customerToUpdate.communicationSubjectId,
        conversation: customerToUpdate.conversation,
        customerFeedback: customerToUpdate.customerFeedback,
        followUpRequired: customerToUpdate.followUpRequired,
        followUpDate: customerToUpdate.followUpDate || '1900-01-01',
        followUpAction: customerToUpdate.followUpAction,
        updatedBy: customerToUpdate.updatedBy,
        previousCommunicationId: customerToUpdate.previousCommunicationId
      };
      const response = await axios.post(
        `${API_url}${API_Controller}`,
        reqModel
      );
      enqueueSnackbar(`Communication Details Added Successfully`, {
        variant: 'success'
      });
      return response.data as CommunicationModel;
    } catch (error) {
      enqueueSnackbar(`Communication Details Add Unsuccessfully`, {
        variant: 'error'
      });
      console.error(error);
      throw error;
    }
  },
  addFollowUpData: async (customerToUpdate: any) => {
    try {
      const reqModel = {
        id: customerToUpdate.id,
        customerId: customerToUpdate.customerId,
        date: customerToUpdate.date,
        communicationTypeId: customerToUpdate.communicationTypeId,
        communicationSubjectId: customerToUpdate.communicationSubjectId,
        conversation: customerToUpdate.conversation,
        customerFeedback: customerToUpdate.customerFeedback,
        followUpRequired: customerToUpdate.followUpRequired,
        followUpDate: customerToUpdate.followUpDate,
        followUpAction: customerToUpdate.followUpAction,
        updatedBy: customerToUpdate.updatedBy,
        previousCommunicationId: customerToUpdate.previousCommunicationId
      };
      const response = await axios.post(
        `${API_url}${API_Controller}`,
        reqModel
      );
      enqueueSnackbar(`Communication Details Added Successfully`, {
        variant: 'success'
      });
      return response.data as CommunicationModel;
    } catch (error) {
      enqueueSnackbar(`Communication Details Add Unsuccessfully`, {
        variant: 'error'
      });
      console.error(error);
      throw error;
    }
  },
  getFollowUp: async (communicationId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/Get_CustomerSelectedFollow_ByCommunicationId?communicationId=${communicationId}`
      );

      return response.data as FollowUpCommunicationModel;
    } catch (error) {
      throw error;
    }
  },
  getFollow: async (communicationId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/Get_CustomerFollowUps_ByCustomerId?customerId=${communicationId}`
      );

      return response.data as FollowUpCommunicationModel[];
    } catch (error) {
      throw error;
    }
  },

  getAllFollowUpsTillToday: async (tillDate: string) => {
  try {
    const response = await axios.get(
      `${API_url}${API_Controller}/GetCommunicationAndFollowUpTillToday`,
      {
        params: {
          tillDate: tillDate
        }
      }
    );

    return response.data as FollowUpCommunicationModel[];
  } catch (error) {
    throw error;
  }
}
};
